import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Timestamp from 'react-timestamp';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import BikeIcon from '../Icon/BikeIcon';
import { putRentEnded, putCloseRent } from '../../store/rents/actions';
import { RENT_IN_PROGRESS } from '../../constants/RentStates';
import { sec2str } from './RentTable';
import { getUsers } from '../../store/users/actions';
import {KOBOO_LIGHT_RED} from "../../constants/colors";
import {getActualTimestamp} from "../../services/DateService";
import Grid from '@material-ui/core/Grid';
import FeedbackBadIcon from '../Icon/FeedbackBadIcon';
import FeedbackNeutralIcon from '../Icon/FeedbackNeutralIcon';
import FeedbackGoodIcon from '../Icon/FeedbackGoodIcon';
import KobooButton from '../Layout/KobooButton';
import Typography from '@material-ui/core/Typography';
import { withWidth } from '@material-ui/core';
import ChatIcon from '@material-ui/icons/Chat';

const styles = () => (
  {
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
    icon: {
      width: '30px',
      height: '30px',
      margin: '-10px',
    },
    button: {
      padding: '3px 15px !important',
      width: 'auto !important',
    },
    smallButton: {
      width: '41px !important',
      minWidth: '40px',
      padding: '8px 8px !important'
    },
    multilineText: {
      textOverflow: 'ellipsis',
      wordBreak: 'break-all'
    },
  }
);

export class RentRow extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      sendingRentId: '',
      role: ROLE_USER,
      width: props.width

    };
  }

  static propTypes = {
    classes: PropTypes.object.isRequired,
    rent: PropTypes.object.isRequired,
    showFeedback: PropTypes.func.isRequired,
    width: PropTypes.string.isRequired
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      newState = {
        ...newState,
        role: props.roles[props.authUser.uid],
      };
      if (!props.users && !props.pendingUsers) {
        props.getUsers();
      }
    }
    if (!props.sending && state.sendingRentId) {
      newState = {
        ...newState,
        sendingRentId: null,
      };
    }
    if (props.users && props.rent && props.rent.user_id in props.users) {
      newState = {
        ...newState,
        user: props.users[props.rent.user_id],
      };
    }
    newState = {
      ...newState,
      width: props.width
    };
    return newState;
  }

  handleClickEndRent = (event, rent) => {
    this.setState({ sendingRentId: rent.id });
    this.props.putRentEnded(
      this.props.authUser.ma,
      rent.id,
      { rent_state: 1 },
    );
    event.preventDefault();
  };

  handleClickForceEndRent = (event, rent) => {
    this.setState({ sendingRentId: rent.id });
    this.props.putCloseRent(
      this.props.authUser.ma,
      rent.id,
      { end_date: getActualTimestamp() },
    );
    event.preventDefault();
  };

  render() {
    const {
      rent,
      classes,
    } = this.props;

    const {
      sendingRentId,
      role,
      user,
    } = this.state;

    return (
      <TableRow
        key={rent.id}
        hover
        tabIndex={-1}
      >
        <TableCell>
          <div className={classes.wrapper}>
            {rent.state}
            {rent.state === RENT_IN_PROGRESS &&
            <Tooltip title="Terminer">
              <IconButton aria-label="update">
                <BikeIcon color="primary" onClick={event => this.handleClickEndRent(event, rent)} />
                {this.props.sending && sendingRentId === rent.id
                && <CircularProgress size={58} className={classes.fabProgress} />}
              </IconButton>
            </Tooltip>
            }
          </div>
        </TableCell>
        <TableCell>
          <Timestamp
            format='full'
            twentyFourHour
            time={rent.start_date}
          />
        </TableCell>
        <TableCell>
          {(
            rent.rent_price !== null && rent.rent_price !== undefined
          )
            ? `${rent.rent_price / 100} €`
            : null
          }
        </TableCell>
        <TableCell>
          {rent.bikeNumber
            ? rent.bikeNumber
            : ''}
        </TableCell>
        {role === ROLE_ADMIN &&
        <TableCell>
          {rent.renterName}
        </TableCell>
        }
        <TableCell>
          {rent.siteName}
        </TableCell>
        <TableCell>
          {rent.endSiteName}
        </TableCell>
        <TableCell>{sec2str((
          rent.end_date
            ?
            rent.end_date
            : new Date() / 1e3 | 0
        ) - rent.start_date)
        }</TableCell>
        <TableCell className={classes.multilineText} title={user ? user.email : ''}>
          {user && user.email}
        </TableCell>
        <TableCell className={classes.multilineText} title={user ? user.mobile : ''}>
          {user && user.mobile}
        </TableCell>
        <TableCell>
          <Grid
            container
            justifyContent={'flex-start'}
            direction={'row'}
            spacing={2}
            alignItems={'center'}
            wrap={'nowrap'}
          >
            <Grid item style={{
              paddingBottom: 0,
              paddingTop: (rent.user_feedback !== null && rent.user_feedback !== '') ? 0 : '5px',
            }}>
              {rent.user_feedback_opinion === 'bad'
              && <FeedbackBadIcon className={classes.icon} />}
              {rent.user_feedback_opinion === 'neutral'
              && <FeedbackNeutralIcon className={classes.icon} />}
              {rent.user_feedback_opinion === 'good'
              && <FeedbackGoodIcon className={classes.icon} />}
            </Grid>
            <Grid item style={{ paddingBottom: 0, paddingTop: 0 }}>
              {rent.user_feedback !== null && rent.user_feedback !== ''
              && <KobooButton
                className={['lg', 'xl'].includes(this.state.width) ? classes.button : classes.smallButton}
                onClick={() => this.props.showFeedback(rent.user_feedback, rent.user_feedback_opinion)}
              >
                {this.state.width === 'xl' && <Typography variant={'button'} noWrap>Lire l'avis</Typography>}
                {this.state.width === 'lg' && <Typography variant={'button'} noWrap>Avis</Typography>}

                {!['lg', 'xl'].includes(this.state.width) && <ChatIcon/>}
              </KobooButton>}
            </Grid>
          </Grid>
        </TableCell>
        {role === ROLE_ADMIN
        && <TableCell style={{ width: '60px' }}>
          {rent.state === RENT_IN_PROGRESS
          && <Tooltip title="Forcer la fin de location">
            <IconButton aria-label="update">
              <BikeIcon
                style={{ color: KOBOO_LIGHT_RED }}
                onClick={event => this.handleClickForceEndRent(event, rent)}
              />
              {this.props.sending && sendingRentId === rent.id
              && <CircularProgress size={58} className={classes.fabProgress} />}
            </IconButton>
          </Tooltip>
          }
        </TableCell>
        }
      </TableRow>
    );
  }
}

function mapStateToProps(state) {
  return {
    pendingUsers: state.users.pending,
    users: state.users.content,
    authUser: state.users.authUser,
    roles: state.roles.content,
    sending: state.rents.sending,
  };
}

export default compose(
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps,
    {
      putRentEnded,
      putCloseRent,
      getUsers,
    },
  ),
)(RentRow);



// WEBPACK FOOTER //
// ./src/components/Rent/RentRow.jsx